'use client';

import { useState } from 'react';
import Link from 'next/link';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import PropertyCard from '../../../components/PropertyCard';
import FilterPanel from '../../../components/FilterPanel';
import HorizontalFilterBar from '../../../components/HorizontalFilterBar';
import AdBanner from '../../../components/AdBanner';

// Mock Civil Services Data
const mockServices = [
    {
        id: 'civil-001',
        title: 'Professional Home Painting Service',
        price: 8,
        priceUnit: '/sqft',
        pricePerSqft: null,
        type: 'Painting',
        experience: '5 Years',
        rating: '4.8',
        locality: 'Anna Nagar',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=600',
        imageCount: 4,
        badges: ['Verified Pro'],
        isNew: true,
        isVerified: true,
        isSaved: false,
        listingType: 'civil',
    },
    {
        id: 'civil-002',
        title: 'Expert Plumbing Solutions',
        price: 500,
        priceUnit: 'Visit',
        pricePerSqft: null,
        type: 'Plumbing',
        experience: '8 Years',
        rating: '4.9',
        locality: 'Velachery',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1581092921461-eab62e97a780?w=600',
        imageCount: 2,
        badges: ['Use Mask/Gloves'],
        isNew: false,
        isVerified: true,
        isSaved: false,
        listingType: 'civil',
    },
    {
        id: 'civil-003',
        title: 'Complete Electrical Wiring',
        price: 1500,
        priceUnit: 'Min',
        pricePerSqft: null,
        type: 'Electrical',
        experience: '4 Years',
        rating: '4.5',
        locality: 'T. Nagar',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=600',
        imageCount: 5,
        badges: ['Certified'],
        isNew: false,
        isVerified: true,
        isSaved: false,
        listingType: 'civil',
    },
    {
        id: 'civil-004',
        title: 'Modern Interior Design Service',
        price: 50,
        priceUnit: '/sqft',
        pricePerSqft: null,
        type: 'Interior Design',
        experience: '7 Years',
        rating: '4.9',
        locality: 'ECR',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=600',
        imageCount: 12,
        badges: ['Award Winning'],
        isNew: true,
        isVerified: true,
        isSaved: false,
        listingType: 'civil',
    },
    {
        id: 'civil-005',
        title: 'Skilled Carpentry & Furniture',
        price: 800,
        priceUnit: 'Visit',
        pricePerSqft: null,
        type: 'Carpentry',
        experience: '10 Years',
        rating: '4.6',
        locality: 'Adyar',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1610557892470-55d9e80c0bce?w=600',
        imageCount: 6,
        badges: [],
        isNew: false,
        isVerified: true,
        isSaved: false,
        listingType: 'civil',
    },
    {
        id: 'civil-006',
        title: 'Home Renovation Package',
        price: 5,
        priceUnit: 'Lakh',
        pricePerSqft: null,
        type: 'Renovation',
        experience: '12 Years',
        rating: '4.7',
        locality: 'OMR',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600',
        imageCount: 8,
        badges: ['Full Package'],
        isNew: true,
        isVerified: true,
        isSaved: false,
        listingType: 'civil',
    },
];

// Mock Ad Data (Civil specific)
const adBanners = [
    {
        id: 'ad-civil-001',
        title: 'Renovate Your Home',
        description: 'Get free consultation for full home renovation packages starting @ ₹3 Lakhs.',
        image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600',
        ctaText: 'Get Quote'
    },
    {
        id: 'ad-civil-002',
        title: 'Expert Interior Designers',
        description: 'Transform your space with our premium interior design partners.',
        image: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=600',
        ctaText: 'Book Now'
    }
];

const sortOptions = [
    { value: 'relevance', label: 'Relevance' },
    { value: 'rating', label: 'Top Rated' },
    { value: 'experience', label: 'Most Experienced' },
    { value: 'price_low', label: 'Price: Low to High' },
];

export default function CivilServicesPage() {
    const [filters, setFilters] = useState({});
    const [sortBy, setSortBy] = useState('relevance');
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        // API call will go here
        console.log('Filters changed:', newFilters);
    };

    const handleSave = (serviceId) => {
        console.log('Save service:', serviceId);
    };

    return (
        <>
            <Navbar />
            <main className="min-h-screen">
                {/* Horizontal Filter Bar - Sticky */}
                <div className="hidden lg:block sticky top-16 z-40 shadow-lg shadow-primary/10">
                    <HorizontalFilterBar
                        filters={filters}
                        onChange={handleFilterChange}
                        listingType="civil"
                    />
                </div>

                {/* Page Header */}
                <div className="bg-gray">
                    <div className="container-custom py-4">
                        <div className="flex items-center mb-3 justify-between mt-5 min-h-[40px]">
                            <nav className="flex items-center gap-2 text-sm text-gray-500" aria-label="Breadcrumb">
                                <Link href="/" className="hover:text-primary">Home</Link>
                                <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                                <span className="text-gray-900 font-medium">
                                    <strong> Available {mockServices.length}+ Civil Services </strong> in Adyar, Chennai
                                </span>
                            </nav>
                            <div className="flex items-center gap-2">
                                <select
                                    id="sortBy"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                    className="h-8 text-sm px-2 pr-6 rounded-md bg-white border border-gray-300 text-gray-700 
                     shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                                >
                                    {sortOptions.map((opt) => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Content Split Layout */}
                <div className="container-custom py-8">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">

                        {/* Left: Service List (8 cols) */}
                        <div className="lg:col-span-8 flex flex-col gap-4">
                            {/* Mobile Filter Button */}
                            <div className="lg:hidden mb-6">
                                <button
                                    onClick={() => setIsMobileFilterOpen(true)}
                                    className="btn btn-secondary w-full flex justify-between items-center"
                                >
                                    <span className="flex items-center gap-2">
                                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                                        </svg>
                                        Filters
                                    </span>
                                    {Object.keys(filters).length > 0 && (
                                        <span className="bg-primary text-white text-xs px-2 py-0.5 rounded-full">
                                            {Object.keys(filters).length}
                                        </span>
                                    )}
                                </button>
                            </div>

                            {/* Service Cards */}
                            {mockServices.map((service) => (
                                <PropertyCard
                                    key={service.id}
                                    property={service}
                                    listingType='civil'
                                    onSave={handleSave}
                                    variant="horizontal"
                                />
                            ))}

                            {/* Load More */}
                            <div className="mt-8 text-center">
                                <button className="btn btn-white border border-gray-200 hover:border-primary hover:text-primary px-8 w-full sm:w-auto">
                                    Load More Services
                                </button>
                            </div>
                        </div>

                        {/* Right: Ad Sidebar (4 cols) */}
                        <aside className="lg:col-span-4 hidden lg:flex flex-col gap-3 sticky top-24">
                            <div className="p-6 bg-green-50 rounded-2xl border border-green-200">
                                <h3 className="text-lg font-bold text-green-900 mb-2">Become a Supplier</h3>
                                <p className="text-sm text-green-700 mb-4">
                                    Join our platform and connect with thousands of customers looking for civil services.
                                </p>
                                <Link href="/become-civil-suppliers" className="w-full btn bg-green-600 text-white hover:bg-green-700 border-none inline-block text-center">
                                    Register Now
                                </Link>
                            </div>
                            <div className="p-6 bg-blue-50 rounded-2xl border border-blue-100">
                                <h3 className="text-lg font-bold text-blue-900 mb-2">Verified Professionals</h3>
                                <p className="text-sm text-blue-700 mb-4">
                                    Hire top-rated civil service experts for your home needs. Background checked & Verified.
                                </p>
                                <button className="w-full btn bg-blue-600 text-white hover:bg-blue-700 border-none">
                                    Post a Requirement
                                </button>
                            </div>

                            {adBanners.map((ad) => (
                                <AdBanner
                                    key={ad.id}
                                    {...ad}
                                />
                            ))}
                        </aside>
                    </div>
                </div>

                {/* Mobile Filter Modal */}
                {isMobileFilterOpen && (
                    <div className="fixed inset-0 z-50 lg:hidden">
                        <div
                            className="absolute inset-0 bg-black/50"
                            onClick={() => setIsMobileFilterOpen(false)}
                        />
                        <div className="absolute right-0 top-0 bottom-0 w-full max-w-sm bg-white overflow-y-auto">
                            <FilterPanel
                                filters={filters}
                                onChange={handleFilterChange}
                                listingType="civil"
                                isMobile={true}
                                onClose={() => setIsMobileFilterOpen(false)}
                            />
                        </div>
                    </div>
                )}
            </main>
            <Footer />
        </>
    );
}
